<div class="w-full mx-auto p-5 space-y-6">
  <!-- Header -->
  <div class="flex flex-wrap justify-between items-center gap-4">
    <div>
      <h1 class="text-2xl font-bold text-gray-800">Configuración de Conciliación</h1>
      <p class="text-gray-500 mt-1">Configura las notificaciones y ajustes de la conciliación automática de reportes.</p>
    </div>
  </div>

  <!-- Status Card -->
  <div class="bg-white rounded-xl border border-gray-200 shadow-sm p-5">
    <div class="flex items-center justify-between flex-wrap gap-4 mb-4">
      <div>
        <h2 class="text-lg font-semibold text-gray-800">Estado de la Conciliación Automática</h2>
        <p class="text-gray-500 text-sm mt-1">La conciliación se ejecuta todos los días a las 06:00 AM</p>
      </div>
      <div class="flex items-center gap-4">
        <button 
          (click)="runManualConciliation()"
          class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors flex items-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Ejecutar Ahora
        </button>
        <button 
          (click)="toggleConciliation()"
          [disabled]="isSavingEnabled || isLoadingEnabled"
          class="relative inline-flex h-7 w-14 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none"
          [ngClass]="conciliationEnabled ? 'bg-emerald-500' : 'bg-gray-300'">
          <span 
            class="pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
            [ngClass]="conciliationEnabled ? 'translate-x-7' : 'translate-x-0'">
          </span>
        </button>
      </div>
    </div>
    <div class="flex items-center gap-2">
      <div [ngClass]="conciliationEnabled ? 'bg-emerald-500' : 'bg-gray-400'" 
           class="w-3 h-3 rounded-full"></div>
      <span [ngClass]="conciliationEnabled ? 'text-emerald-600' : 'text-gray-500'" class="font-medium">
        {{ conciliationEnabled ? 'Habilitada' : 'Deshabilitada' }}
      </span>
    </div>
  </div>

  <!-- Email Configuration Card -->
  <div class="bg-white rounded-xl border border-gray-200 shadow-sm p-5">
    <h2 class="text-lg font-semibold text-gray-800 mb-2">Emails de Notificación</h2>
    <p class="text-gray-500 text-sm mb-5">Estos emails recibirán el resumen de cada conciliación automática.</p>

    <!-- Add Email Form -->
    <div class="flex gap-3 mb-5">
      <input 
        type="email" 
        [(ngModel)]="newEmail"
        (keyup.enter)="addEmail()"
        placeholder="email@ejemplo.com"
        class="flex-1 bg-gray-50 border border-gray-300 rounded-lg px-4 py-2.5 text-gray-800 placeholder-gray-400 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none transition-colors">
      <button 
        (click)="addEmail()"
        [disabled]="isSavingEmails || !newEmail.trim()"
        class="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white font-medium px-6 py-2.5 rounded-lg transition-colors flex items-center gap-2">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
        </svg>
        Agregar
      </button>
    </div>

    <!-- Email List -->
    <div class="space-y-2">
      <div *ngIf="isLoadingEmails" class="text-center py-8">
        <div class="animate-spin w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full mx-auto"></div>
      </div>

      <div *ngIf="!isLoadingEmails && emails.length === 0" class="text-center py-8 text-gray-400">
        No hay emails configurados
      </div>

      <div *ngFor="let email of emails; let i = index" 
           class="flex items-center justify-between bg-gray-50 rounded-lg px-4 py-3 border border-gray-200">
        <div class="flex items-center gap-3">
          <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          <span class="text-gray-700">{{ email }}</span>
        </div>
        <button 
          (click)="removeEmail(i)"
          class="text-gray-400 hover:text-red-500 transition-colors p-1">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Conciliation Logs -->
  <div class="bg-white rounded-xl border border-gray-200 shadow-sm p-5">
    <div class="flex items-center justify-between mb-5">
      <h2 class="text-lg font-semibold text-gray-800">Historial de Conciliaciones</h2>
      <button 
        (click)="loadConciliationLogs()"
        class="text-gray-400 hover:text-gray-600 transition-colors p-2">
        <svg class="w-5 h-5" [ngClass]="{'animate-spin': isLoadingLogs}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
      </button>
    </div>

    <!-- Loading -->
    <div *ngIf="isLoadingLogs" class="text-center py-8">
      <div class="animate-spin w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full mx-auto mb-2"></div>
      <p class="text-gray-500 text-sm">Cargando historial...</p>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoadingLogs && conciliationLogs.length === 0" class="text-center py-8">
      <svg class="w-12 h-12 mx-auto text-gray-300 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
      </svg>
      <p class="text-gray-400">No hay registros de conciliación</p>
    </div>

    <!-- Logs Table -->
    <div *ngIf="!isLoadingLogs && conciliationLogs.length > 0" class="overflow-x-auto">
      <table class="w-full text-sm">
        <thead>
          <tr class="text-left text-gray-500 border-b border-gray-200">
            <th class="pb-3 font-medium">Fecha</th>
            <th class="pb-3 font-medium">Estado</th>
            <th class="pb-3 font-medium">Procesados</th>
            <th class="pb-3 font-medium">Conciliados</th>
            <th class="pb-3 font-medium">Pendientes</th>
            <th class="pb-3 font-medium">Tiempo</th>
            <th class="pb-3 font-medium">Email</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let log of conciliationLogs" class="border-b border-gray-100 hover:bg-gray-50">
            <td class="py-3 text-gray-700">{{ formatDate(log.executionDate) }}</td>
            <td class="py-3">
              <span [ngClass]="getStatusClass(log.status)" class="px-2 py-1 rounded-full text-xs font-medium">
                {{ getStatusLabel(log.status) }}
              </span>
            </td>
            <td class="py-3 text-gray-600">{{ log.totalProcessed }}</td>
            <td class="py-3 text-emerald-600 font-medium">{{ log.totalConciliated }}</td>
            <td class="py-3 text-amber-600">{{ log.totalPending }}</td>
            <td class="py-3 text-gray-500">{{ log.executionTimeMs }}ms</td>
            <td class="py-3">
              <span *ngIf="log.emailNotificationSent" class="text-emerald-500">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              <span *ngIf="!log.emailNotificationSent" class="text-gray-300">-</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Info Card -->
  <div class="bg-blue-50 rounded-xl p-5 border border-blue-200">
    <h3 class="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
      <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      Información
    </h3>
    <ul class="space-y-2 text-gray-600 text-sm">
      <li class="flex items-start gap-2">
        <svg class="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        La conciliación automática se ejecuta todos los días a las 6:00 AM.
      </li>
      <li class="flex items-start gap-2">
        <svg class="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        Se comparan los reportes Wompi (CSV) con los reportes Plink (Excel) usando el código de autorización.
      </li>
      <li class="flex items-start gap-2">
        <svg class="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        Los descuentos de Plink se aplican automáticamente a los pagos correspondientes.
      </li>
      <li class="flex items-start gap-2">
        <svg class="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        Los emails configurados recibirán un resumen detallado después de cada conciliación.
      </li>
    </ul>
  </div>
</div>
